import styled, { css } from 'styled-components/native';
import { RFValue } from 'react-native-responsive-fontsize';
import { getBottomSpace } from 'react-native-iphone-screen-helper';
import { Platform } from 'react-native';
import FastImage from 'react-native-fast-image';

type VehicleCardState = 'loading' | 'success' | 'error';

interface VehicleCardProps {
  state?: VehicleCardState;
}

export const Container = styled.ScrollView`
  background-color: ${({ theme }) => theme.colors.background};

`;

export const ContentHeader = styled.View`
  flex-direction: column;
  margin-top: ${RFValue(24)}px;
  padding: 0 24px;
  justify-content: space-between;
`;


export const Title = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(13)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;


export const Content = styled.View`
  padding: ${RFValue(16)}px 24px 0;
  padding-bottom: ${RFValue(94)}px;
`;

export const Form = styled.View``;

export const InputGroup = styled.View`
  margin-bottom: ${RFValue(12)}px;
`;

export const Footer = styled.View`
  padding: 0 24px;
  padding-bottom: ${Platform.OS === 'ios' && getBottomSpace()
    ? 0
    : RFValue(20)}px;
`;

export const BannerPanel = styled.TouchableOpacity`
  border-radius: ${RFValue(12)}px;
  overflow: hidden;
  width: 100%;
  margin-bottom: ${RFValue(16)}px;
`;

export const BannerImage = styled(FastImage)`
  width: 100%;
  aspect-ratio: ${1066 / 193};
  border-radius: ${RFValue(12)}px;
`;

export const VehicleCard = styled.View<VehicleCardProps>`
  border-radius: ${RFValue(12)}px;
  flex-direction: row;
  align-items: center;
  min-height: ${RFValue(62)}px;
  padding: ${RFValue(12)}px ${RFValue(14)}px;
  margin-bottom: ${RFValue(12)}px;
  gap: ${RFValue(12)}px;
  overflow: hidden;

  ${({ state, theme }) => {
    if (state === 'error') {return css`
      background-color: ${theme.colors.attention_opacity};
      border-left-width: 3px;
      border-left-color: ${theme.colors.attention};
      border-top-width: 0px;
      border-right-width: 0px;
      border-bottom-width: 0px;
    `;}
    if (state === 'loading') {return css`
      background-color: ${theme.colors.background_secondary};
      border-width: 1px;
      border-color: ${theme.colors.border};
    `;}
    return css`
      background-color: ${theme.colors.blue_main_opacity};
      border-left-width: 3px;
      border-left-color: ${theme.colors.blue};
      border-top-width: 0px;
      border-right-width: 0px;
      border-bottom-width: 0px;
      shadow-radius: 6px;
    `;
  }}
`;

export const VehicleCardInfo = styled.View`
  flex: 1;
`;

export const VehicleCardModel = styled.Text`
  font-size: ${RFValue(13)}px;
  font-family: ${({ theme }) => theme.fonts.semibold};
  color: ${({ theme }) => theme.colors.title};
`;

export const VehicleCardDetails = styled.Text`
  font-size: ${RFValue(11)}px;
  font-family: ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.text};
  margin-top: ${RFValue(2)}px;
`;

export const VehicleCardError = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.attention};
  flex: 1;
`;

interface SkeletonLineProps {
  width?: string;
  height?: number;
}

export const VehicleCardSkeletonLine = styled.View<SkeletonLineProps>`
  height: ${({ height }) => RFValue(height ?? 11)}px;
  border-radius: ${RFValue(4)}px;
  background-color: ${({ theme }) => theme.colors.border};
  width: ${({ width }) => width ?? '60%'};
`;

export const TrustBadgesRow = styled.View`
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  margin-top: ${RFValue(12)}px;
  margin-bottom: ${RFValue(4)}px;
`;

export const TrustBadgeItem = styled.View`
  align-items: center;
  justify-content: center;
  gap: ${RFValue(2)}px;
  flex: 1;
`;

export const TrustBadgeIconWrapper = styled.View`
  width: ${RFValue(36)}px;
  height: ${RFValue(36)}px;
  border-radius: ${RFValue(18)}px;
  background-color: #27ae6022;
  align-items: center;
  justify-content: center;
`;

export const SenatranBadge = styled.View`
  flex-direction: row;
  align-items: center;
  gap: ${RFValue(4)}px;
`;

export const SenatranSelo = styled.Image`
  width: ${RFValue(28)}px;
  height: ${RFValue(32)}px;
`;

export const SenatranTextWrapper = styled.View``;

export const SenatranLabel = styled.Text`
  font-size: ${RFValue(8)}px;
  font-family: ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: -${RFValue(4)}px;
`;

export const SenatranTitle = styled.Text`
  font-size: ${RFValue(14)}px;
  font-family: ${({ theme }) => theme.fonts.bold};
  color: #5a7a2b;
`;

export const TrustBadgePercentWrapper = styled.View`
  width: ${RFValue(28)}px;
  height: ${RFValue(28)}px;
  border-radius: ${RFValue(14)}px;
  background-color: #10AECA22;
  align-items: center;
  justify-content: center;
`;

export const TrustBadgeText = styled.Text`
  font-size: ${RFValue(10)}px;
  line-height: ${RFValue(12)}px;
  font-family: ${({ theme }) => theme.fonts.semibold};
  color: ${({ theme }) => theme.colors.title};
  text-align: left;
`;

export const TrustBadgeSenatranImage = styled.Image`
  width: ${RFValue(36)}px;
  height: ${RFValue(41)}px;
`;

export const TrustBadgePciImage = styled.Image`
  width: ${RFValue(58)}px;
  height: ${RFValue(29)}px;
`;

export const TrustBadgeDivider = styled.View`
  width: 1px;
  height: ${RFValue(40)}px;
  background-color: ${({ theme }) => theme.colors.border};
`;

export const SupportContainer = styled.View`
  margin-top: ${RFValue(16)}px;
  padding: ${RFValue(12)}px ${RFValue(14)}px;
  border-radius: ${RFValue(12)}px;
  background-color: ${({theme}) => theme.colors.alert};
`;

export const SupportText = styled.Text`
  font-size: ${RFValue(11)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  text-align: center;
  line-height: ${RFValue(17)}px;
`;

export const SupportPhone = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.blue};
`;
